/**
 * Рекомендации: раскрытие разделов, переход по навигации и учёт
 * прочитанного.
 *
 * Прочитанным считается раздел, который человек раскрыл. Первый
 * раскрыт всегда, поэтому он засчитывается сразу при входе: прочитать
 * его можно, не делая ничего, и до захода на карточке стоит 0,
 * а после — минимум 1 (решение владельца 27.10).
 *
 * Отметки хранятся на сервере, а не в браузере: это счётчик достижения,
 * и он должен быть один на всех устройствах. Коды только добавляются —
 * свернув раздел, человек не «забывает» его.
 *
 * Слушаем документ целиком: навигация стоит в двух местах сразу —
 * в боковой колонке и в листе за тремя точками на телефоне.
 */
import CookiesJS from 'cookies-js';

export function initRecommendations($, apiClient) {
    const $root = $('.js-recommendations');
    if (!$root.length) return;

    const userId = ($root.attr('data-user-id') || '').trim();
    const $document = $(document);
    // Коды, о которых сервер ещё не знает. Копим и отправляем пачкой:
    // человек раскрывает разделы один за другим, и запрос на каждый клик
    // был бы очередью из пятнадцати.
    const pending = new Set();
    let timer = null;

    function flush() {
        if (!userId || !pending.size) return;
        const codes = Array.from(pending);
        pending.clear();
        apiClient.addRecommendationsRead(userId, codes, CookiesJS.get('auth_token')).catch((error) => {
            // Молча: счётчик — не то, ради чего стоит беспокоить
            // человека сообщением. Коды вернём в очередь, следующий
            // раскрытый раздел увезёт их с собой.
            console.warn('Не удалось отметить прочитанное', error);
            codes.forEach((code) => {
                pending.add(code);
                $(`.recommendation-item[data-code="${code}"]`).attr('data-stored', '0');
            });
        });
    }

    function markRead(code) {
        if (!code) return;
        // Полоса закрашивается в обеих копиях навигации — в колонке
        // и в листе за тремя точками.
        $(`.js-recommendation-anchor[data-code="${code}"] .recommendation-section-link__bar-fill`)
            .addClass('is-read');
        const $item = $(`.recommendation-item[data-code="${code}"]`);
        // Решаем по тому, что записано на сервере, а не по виду полосы:
        // у первого раздела она закрашена с самого начала, и проверка
        // по ней означала бы, что он не отметится никогда.
        if ($item.attr('data-stored') === '1') return;
        $item.attr('data-stored', '1');
        pending.add(code);
        if (timer) clearTimeout(timer);
        timer = setTimeout(flush, 600);
    }

    function setOpen($item, isOpen) {
        $item.toggleClass('is-open', isOpen);
        $item.find('.js-recommendation-toggle').attr('aria-expanded', isOpen ? 'true' : 'false');
        if (isOpen) markRead($item.attr('data-code'));
    }

    $document.on('click', '.js-recommendation-toggle', function () {
        const $item = $(this).closest('.recommendation-item');
        setOpen($item, !$item.hasClass('is-open'));
    });

    // Переход по навигации раскрывает раздел: человек выбрал его
    // в списке, значит хочет прочитать, а не увидеть закрытую полосу.
    $document.on('click', '.js-recommendation-anchor', function (event) {
        const code = $(this).attr('data-code');
        const $item = $(`.recommendation-item[data-code="${code}"]`);
        if (!$item.length) return;
        event.preventDefault();
        setOpen($item, true);
        // Лист на телефоне перекрывает экран целиком — его надо закрыть,
        // иначе подскролл произойдёт под ним.
        const menu = document.querySelector('.client-menu');
        if (menu && !menu.hidden) {
            menu.hidden = true;
            document.body.style.overflow = '';
        }
        $item[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    // Первый раздел раскрыт разметкой — засчитываем его при входе.
    const $first = $root.find('.recommendation-item').first();
    if ($first.hasClass('is-open')) markRead($first.attr('data-code'));

    // Страницу закрывают раньше, чем истечёт пауза: успеваем отправить.
    window.addEventListener('pagehide', flush);
}
